import { Link } from 'react-router-dom'
import { ShieldOff } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Card, CardContent } from '@/components/ui/Card'
import { MAIN_SITE_URL } from '@/lib/config'

export function AccessDeniedPage() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <Card className="max-w-md w-full text-center">
        <CardContent className="pt-10 pb-10 px-8">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[rgba(248,113,113,0.1)] text-[#fca5a5] ring-1 ring-[rgba(248,113,113,0.2)] mb-5">
            <ShieldOff className="h-7 w-7" />
          </div>
          <h2 className="text-xl font-bold tracking-[-0.02em] text-[#f0f4f8]">Access denied</h2>
          <p className="text-sm text-[#9aabbb] mt-3 leading-relaxed">
            This portal is restricted to authorized clyr staff. If you believe you should have access,
            contact Head of Trust &amp; Safety or an executive.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
            <a href={MAIN_SITE_URL}>
              <Button variant="secondary" className="w-full sm:w-auto">Back to clyr</Button>
            </a>
            <Link to="/login">
              <Button className="w-full sm:w-auto">Sign in</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
